import { FC } from 'react';
import { Tooltip } from 'react-leaflet';
import { makeStyles } from '../../../../theme';
import { Display, MapPanes } from '../../../../types';

const useStyles = makeStyles()((theme) => ({
  tooltip: {
    backgroundColor: `${theme.palette.common.black} !important`,
    border: 'none',
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.common.white,
    paddingLeft: '12px',
    paddingRight: '12px',
    zIndex: 700,
    '&:before': { display: 'none' },
  },
}));

export const GeofenceTooltip: FC<Display> = ({ display }) => {
  const { classes } = useStyles();

  return (
    <Tooltip className={classes.tooltip} direction="right" pane={MapPanes.POPUP_PANE} sticky>
      {display}
    </Tooltip>
  );
};
